import React from 'react';
import Form from 'react-bootstrap/Form';
import SearchTable from './SearchTable';
import Container from 'react-bootstrap/Container';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import TablePagination from './TablePagination';
import FormattedDate from './FormattedDate';
import "bootstrap/js/src/collapse.js";

class RelaySearchForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {value: ''};
    this.handleChange = this.handleChange.bind(this);
    this.handleLimitChange = this.handleLimitChange.bind(this);
  }

  handleChange(event) {
    this.props.onSearchQueryChange(event.target.value);
  }

  handleLimitChange(event) {
    this.props.onLimitChange(event.target.value);
  }

  render() {
    const searchQuery = this.props.searchQuery;
    return (
      <Form>
          <Form.Group controlId="searchForm.search">
          <Form.Label>Search</Form.Label>
          <Form.Control type="text" placeholder="Search" value={searchQuery} />
          </Form.Group>
      </Form>
    );
  }
}

function onionooDetailsSearchURL(query, limit, page) {
  var url = "https://onionoo.torproject.org/details?";
  url += "limit=" + limit;
  url += "&offset=" + (limit * (page - 1));
  if (query)
    url += "&search=" + encodeURIComponent(query).replace("%3A", ":");
  return url;
}


class RelaySummary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      details: null,
      limit: 0,
      page: 0,
    };
    this.handlePageChange = this.handlePageChange.bind(this)
  }

  serverCount() {
    const priorPages = this.state.page;
    const relays_truncated = this.state.details.relays_truncated || 0;
    const bridges_truncated = this.state.details.bridges_truncated || 0;
    return (priorPages * this.state.limit) + relays_truncated + bridges_truncated;
  }

  pageCount() {
    return Math.ceil(this.serverCount() / this.state.limit)
  }

  updateResults(query, limit, page) {
    fetch(onionooDetailsSearchURL(query, limit, page))
      .then(response => response.json())
      .then(data => this.setState({'page': page, 'limit': limit, 'details': data}));
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.search !== this.props.search
          || nextProps.limit !== this.props.limit)
      this.updateResults(nextProps.search, nextProps.limit, 1);
  }

  componentDidMount() {
    this.updateResults(this.props.search, this.props.limit, 1);
  }

  handlePageChange(page) {
    if (page > 0 && page <= this.pageCount())
      this.updateResults(this.props.search, this.state.limit, parseInt(page));
    else console.log("page change out of range " + this.pageCount());
  }

  render() {
    const startResult = ((this.state.page - 1) * this.state.limit) + 1;
    const endResult = startResult - 1
      + (this.state.details && this.state.details.relays ? this.state.details.relays.length : 0)
      + (this.state.details && this.state.details.bridges ? this.state.details.bridges.length : 0);
    return (
      <>
      <Container>
        <h1>Relay Search</h1>
        <h2>{this.props.search || "The Entire Network"}</h2>
      </Container>
        {this.state.details
          ? <><Container>
            <SearchTable details={this.state.details} />
            <p>Showing results {startResult}-{endResult} of {this.serverCount()}.</p>
            <TablePagination
              changePage={this.handlePageChange}
              currentPage={this.state.page}
              lastPage={this.pageCount()} />
            <p>
              <sup>†</sup>The number shown in parentheses is the total effective
              family size for the relay including the relay itself. A size of 1
              indicates that the relay does not have any other effective family
              members. Note that bridge relays do not advertise family members
              in their descriptors and so there is no value shown for bridge
              relays.
            </p>
            </Container>
            <footer class="bg-light p-3 mt-5">
              <Container>
            {['relays', 'bridges'].map((server) => (
               <>
                Information for {server} was published: {" "}
                <OverlayTrigger
                  key={server}
                  placement="top"
                  overlay={
                    <Tooltip id={server}>
                      <FormattedDate date={this.state.details.relays_published} /> ago
                    </Tooltip>
                  }
                >
                  <span>{this.state.details.relays_published}</span>
                </OverlayTrigger>.
            <br /></>
            ))}
                Onionoo version: {" "}
                {this.state.details.version}/
                {this.state.details.build_revision}.
              </Container>
            </footer>
          </>
          : <Container>Loading</Container>}
        </>
    );
  }
}

export default RelaySummary;
export { RelaySearchForm };
